export const AGREEMENT_TYPE_TOU = 1
export const AGREEMENT_TYPE_PRIVACY = 2
export const AGREEMENT_TYPE_GAME = 3
export const AGREEMENT_TYPE_API = 4
export const AGREEMENT_TYPE_MONETIZATION = 5
export const AGREEMENT_TYPE_AUP = 6

export const MEMBER_LEVEL_GUEST = 0
export const MEMBER_LEVEL_MEMBER = 1
export const MEMBER_LEVEL_CONTRIBUTOR = 2
export const MEMBER_LEVEL_MANAGER = 4
export const MEMBER_LEVEL_LEADER = 8

export const TEAM_MEMBER_LEVEL_MODERATOR = 1
export const TEAM_MEMBER_LEVEL_MANAGER = 4
export const TEAM_MEMBER_LEVEL_ADMINISTRATOR = 8

export const USER_PRIVACY_EVERYONE = 0
export const USER_PRIVACY_SUBSCRIBERS = 1
export const USER_PRIVACY_NONE = 2
export const USER_PRIVACY_EVERYONE_NO_COMMENTS = 3

export const STATUS_NOT_ACCEPTED = 0
export const STATUS_ACCEPTED = 1
export const STATUS_DELETED = 3
export const STATUS_BANNED = 4

export const VISIBLE_HIDDEN = 0
export const VISIBLE_PUBLIC = 1

export const PLATFORM_STATUS_APPROVED = 1

export const PAGINATION_DEFAULT_PAGE = 1
export const PAGINATION_DEFAULT_TOTAL = 0
export const PAGINATION_DEFAULT_LIMIT = 30

export const MIN_AGE_DEFAULT = 13

export const RATINGS_LIKE = 1
export const RATINGS_DISLIKE = -1
export const RATINGS_UNDECIDED = 0
export const RATINGS_FEW = 5
export const RATINGS_MANY = 50

export const API_THIRD_PARTY_ACCESS = 1
export const API_DIRECT_DOWNLOAD = 2

export const GAME_COMMUNITY_ALLOW_NEGATIVE_RATINGS = 256

export const COMMENT_PINNED = 1
export const COMMENT_LOCKED = 2

export const AGREEMENT_TYPE_OPTIONS = [
  {
    value: AGREEMENT_TYPE_TOU,
    text: 'Terms of Use',
    short: 'Terms',
    paths: ['terms'],
  },
  {
    value: AGREEMENT_TYPE_AUP,
    text: 'Acceptable Use Policy',
    short: 'AUP',
    paths: ['aup'],
  },
  {
    value: AGREEMENT_TYPE_PRIVACY,
    text: 'Privacy Policy',
    short: 'Privacy',
    paths: ['privacy'],
  },
  {
    value: AGREEMENT_TYPE_MONETIZATION,
    text: 'Monetization Terms',
    short: 'Monetization',
    paths: ['monetization'],
  },
  {
    value: AGREEMENT_TYPE_API,
    text: 'API Access Terms',
    short: 'API',
    paths: ['apiterms'],
  },
  {
    value: AGREEMENT_TYPE_GAME,
    text: 'Game Terms',
    short: 'Game',
    paths: ['gameterms'],
  },
]

export const STATUS_OPTIONS = [
  { value: STATUS_NOT_ACCEPTED, text: 'Pending' },
  { value: STATUS_ACCEPTED, text: 'Accepted' },
  { value: STATUS_DELETED, text: 'Deleted' },
  { value: STATUS_BANNED, text: 'Banned' },
]

export const REPORT_TYPE_DMCA = 1

export const REPORT_TYPE_OPTIONS = [
  // API 0=generic, however it should not be a selectable option on report
  { value: 0, text: '' },
  { value: REPORT_TYPE_DMCA, text: 'report_dmca' },
  { value: 2, text: 'report_not_working' },
  { value: 3, text: 'report_rude_content' },
  { value: 4, text: 'report_illegal_content' },
  { value: 5, text: 'report_stolen_content' },
  { value: 6, text: 'report_false_information' },
  { value: 7, text: 'report_other' },
]

// These values are consistent with the API
export const RESOURCE_GAMES = 'games'
export const RESOURCE_MODS = 'mods'
export const RESOURCE_GUIDES = 'articles'
export const RESOURCE_USERS = 'users'

export const RESOURCE_OPTIONS = {
  [RESOURCE_GAMES]: 'Game',
  [RESOURCE_MODS]: 'Mod',
  [RESOURCE_GUIDES]: 'Guide',
  [RESOURCE_USERS]: 'User',
}

export const DISCUSSION_TYPE_MODS = 'mods'
export const DISCUSSION_TYPE_GUIDES = 'guides'
export const DISCUSSION_TYPES = [DISCUSSION_TYPE_MODS, DISCUSSION_TYPE_GUIDES]

export const RATINGS_TEXT_OPTIONS = {
  UNRATED: 'unrated',
  OVERWHELMINGLY_POSITIVE: 'overwhelmingly_positive',
  VERY_POSITIVE: 'very_positive',
  POSITIVE: 'positive',
  MOSTLY_POSITIVE: 'mostly_positive',
  MIXED: 'mixed',
  MOSTLY_NEGATIVE: 'mostly_negative',
  NEGATIVE: 'negative',
  VERY_NEGATIVE: 'very_negative',
  OVERWHELMINGLY_NEGATIVE: 'overwhelmingly_negative',
}

export const GAME_PLATFORMS = [
  'source',
  'windows',
  'mac',
  'linux',
  'android',
  'ios',
  'oculus',
  'xboxone',
  'xboxseriesx',
  'ps4',
  'ps5',
  'switch',
]

export const GAME_PLATFORM_LABELS = {
  source: 'Source',
  windows: 'Windows',
  mac: 'Mac',
  linux: 'Linux',
  android: 'Android',
  ios: 'iOS',
  xboxone: 'Xbox One',
  xboxseriesx: 'Xbox Series X/S',
  ps4: 'PlayStation 4',
  ps5: 'PlayStation 5',
  switch: 'Nintendo Switch',
  oculus: 'Oculus',
}

export const PLATFORM_FILTERS_TO_HIDE = ['source']
